import { NzTreeNodeOptions } from "ng-zorro-antd/tree";
import { GoalParentType } from "../goals/models/goal.models";

export interface IParentOkrSelectorSuggestionSession {
  sessionTitle?: string;
  goals?: IParentOkrSelectorSuggestion[];
}

export type IParentSelectorEntry = (IParentOkrSelectorSearchResult | IParentOkrSelectorSuggestion) & {
  isDraft?: boolean;
  isRestrictedParentSession?: boolean;
};

export type IParentOkrSelectorSearchResult = IParentOkrSelectorGoalResult | IParentOkrSelectorMetricResult;

export interface IParentOkrSelectorSuggestion extends IParentOkrSelectorGoalResult {
  subItems?: IParentOkrSelectorMetricResult[];
  expanded?: boolean;
}

export interface IParentOkrSelectorGoalResult {
  id: string;
  name: string;
  accountId?: string;
  assignees?: IParentOkrSelectorElasticSearchAssignees[];
  attainment?: number;
  description?: string;
  ownerIds?: string[];
  private?: boolean;
  session?: IParentOkrSelectorElasticSearchSession;
  sessionId?: string;
  type: ParentOkrSelectorType;
}

interface IParentOkrSelectorElasticSearchAssignees {
  email: string;
  name: string;
  type: string;
}

interface IParentOkrSelectorElasticSearchSession {
  status: string;
  title: string;
}

export type ParentOkrSelectorType = "goal" | "metric";

interface IParentOkrSelectorMetricResult {
  accountId: string;
  assignees: IParentOkrSelectorElasticSearchAssignees[];
  attainment: number;
  id: string;
  name: string;
  ownerIds: string[];
  session: IParentOkrSelectorElasticSearchSession;
  goalId: string;
  type: ParentOkrSelectorType;
}

export interface IParentSelector {
  id: string;
  type: ParentOkrSelectorType;
}

export interface IParentSelectorNode extends NzTreeNodeOptions {
  ownerIds?: string[];
  type?: ParentOkrSelectorType;
  isSessionTitle?: boolean;
  relevance?: number;
  children?: IParentSelectorNode[];
  hidden?: boolean;
}

export interface IGetParentSelectionItemsParams {
  sessionIds: string[];
  ownerIds?: string[];
  parentId?: string;
  type?: GoalParentType;
  goalIdToExclude?: string;
}

export interface IGetSearchParams {
  searchTerm: string;
  sessionIds: string[];
  goalIdToExclude?: string;
}

export interface IParentSearchResult {
  id: string;
  collectionName: "goals" | "metrics";
  name: string;
  sessionId: string;
  ownerIds: string[];
}

export interface IParentSelectionTeam {
  id: string;
  parentId?: string;
  manager?: string;
  members?: string[];
}

export type ParentSelectorSuggestionsLoadedType = "related" | "similar" | "related&similar" | "none";

export interface ParentSelectorTrackingPayloadMeta {
  location: string;
  suggestionsLoaded: ParentSelectorSuggestionsLoadedType;
  parentId?: string;
  parentType?: ParentOkrSelectorType;
  relevance?: number;
  suggestionsSelected?: "yes" | "no";
  suggestionSelectedRank?: number;
  searchPerformed?: "yes" | "no";
  searchResultSelected?: "selected" | "not selected";
  searchQuery?: string;
  searchResultSelectedRank?: number;
  scrollUsed?: "yes" | "no";
  [key: string]: string | number | boolean;
}

export interface ParentSelectorTrackingPayloadConverted {
  event: string;
  meta: {
    [key: string]: string | number;
  };
}

export enum ParentSelectorSuggestedListType {
  SIMILAR = 0,
  RELATED = 1,
}
